import closeIcon from 'assets/icons/close.svg'

interface ModalHeaderProps {
  title: string
  onClose: () => void
}

export const ModalHeader = ({ title, onClose }: ModalHeaderProps) => (
  <div className="flex items-start justify-between gap-4 w-full pathway-modal-sticky-header p-6">
    <p className="headline-m">{title}</p>
    <button onClick={onClose} aria-label="Close">
      <img src={closeIcon} alt="" width={16} height={16} />
    </button>
  </div>
)
